<template>
  <div class="w-auto h-auto collapse navbar-collapse h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">

      <!-- Dashboard -->
      <li class="nav-item" v-if="isAdmin">
        <sidenav-collapse to="/dashboard" activeRoute="dashboard" navText="Dashboard">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Contacts -->
      <!-- <li class="nav-item">
        <sidenav-collapse to="/contacts" activeRoute="contacts" navText="Contacts">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">contacts</i>
          </template>
        </sidenav-collapse>
      </li> -->

      <!-- Orders -->
      <li class="nav-item">
        <sidenav-collapse to="/orders" activeRoute="orders" navText="Orders">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">receipt_long</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Testimonials -->
      <!-- <li class="nav-item">
        <sidenav-collapse to="/testimonials" activeRoute="testimonials" navText="Testimonials">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">forum</i>
          </template>
        </sidenav-collapse>
      </li> -->

      <!-- Blogs -->
      <!-- <li class="nav-item">
        <sidenav-collapse to="/blogs" activeRoute="blogs" navText="Blogs">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">article</i>
          </template>
        </sidenav-collapse>
      </li> -->

      <!-- Catalog Group -->
      <li class="nav-item">
        <sidenav-collapse navText="Catalog" :children="[
          { to: '/categories', navText: 'Categories', activeRoute: 'categories', icon: 'category' },
          { to: '/sub-categories', navText: 'Sub Categories', activeRoute: 'sub-categories', icon: 'subdirectory_arrow_right' },
          { to: '/products', navText: 'Products', activeRoute: 'products', icon: 'inventory_2' },
          { to: '/products/option-types', navText: 'Option Types', activeRoute: 'option-types', icon: 'settings' },
          { to: '/product-set-items', navText: 'Product Sets', activeRoute: 'product-set-items', icon: 'set_meal' },
        ]">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">menu_book</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Marketing Group -->
      <li class="nav-item">
        <sidenav-collapse navText="Marketing" :children="[
          { to: '/home-banners', navText: 'Banners', activeRoute: 'home-banners', icon: 'image' },
        ]">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">campaign</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Locations Group -->
      <li class="nav-item">
        <sidenav-collapse navText="Locations" :children="[
          { to: '/countries', navText: 'Countries', activeRoute: 'countries', icon: 'public' },
          { to: '/cities', navText: 'Cities', activeRoute: 'cities', icon: 'location_city' },
          { to: '/districts', navText: 'Districts', activeRoute: 'districts', icon: 'location_on' },
        ]">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">travel_explore</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Kiosk -->
      <li class="nav-item">
        <sidenav-collapse to="/settings" activeRoute="settings" navText="Kiosk Settings">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">tv</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- <li class="nav-item">
        <sidenav-collapse navText="Email" :children="[
          { to: '/sendEmail', navText: 'Send Email', activeRoute: 'sendEmail', icon: 'email' },
          { to: '/subscribers', navText: 'Subscribers', activeRoute: 'inbox', icon: 'email' },
        ]">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">email</i>
          </template>
        </sidenav-collapse>
      </li> -->
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import { mapGetters } from "vuex";

export default {
  name: "SidenavList",
  components: {
    SidenavCollapse,
  },
  computed: {
    ...mapGetters("auth", ["isAdmin"]),
  },
};
</script>
